import StateObserver from 'src/StateObserver';
import { closeAllPopups } from 'src/lib/popups/popupOpenClose';
import PopupCheats, { Item } from '../cheats/PopupCheats';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { CheatData } from '../cheats/cheats.sequences';
import { SuperLollipopButton } from './components/SuperLollipopButton';
import { getHomeButton } from '../animation/rewardAnimation';

const MATCH2_SUPER_LOLLIPOP = 'match2 Super Lollipop';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_SUPER_LOLLIPOP] = [
    {
      text: 'Reset Super Lollipop',
      color: 'secondary',
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_resetSuperLollipop();
        getHomeButton<SuperLollipopButton>('superLollipop')?.instantUpdate();
      },
    },
    {
      text: 'Increase Super Lollipop Streak',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_increaseSuperLollipopWinStreak();
        getHomeButton<SuperLollipopButton>('superLollipop')?.instantUpdate();
      },
    },
    {
      text: 'Max Super Lollipop Streak',
      color: 'secondary',
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_increaseSuperLollipopWinStreakToMax();
        getHomeButton<SuperLollipopButton>('superLollipop')?.instantUpdate();
      },
    },
    {
      text: 'Clear Super Lollipop Streak',
      color: 'secondary',
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_clearSuperLollipopWinStreak();
        getHomeButton<SuperLollipopButton>('superLollipop')?.instantUpdate();
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  if (args.key !== MATCH2_SUPER_LOLLIPOP) return;
  args.title.updateOpts({
    width: args.item.style.width - 40,
    height: 20,
    y: 8,
    align: 'center',
  });
  args.popup.createVerticalButtons(args.item, args.setting);
};

export const superLollipopCheats = {
  list,
  ui,
};
